// gameUtils.js
import React from 'react'
import { getLanguageType } from 'constants/Language'

export const handleGameClick = async (gameId, user, setLoading, handleErrorCode) => {
  const language = getLanguageType().name
  const gamblerId = user ? user.get('gamblerId') : null
  const queryParam = gamblerId ? `?gamblerId=${gamblerId}&language=${language}` : `?language=${language}`

  try {
    setLoading(true)

    const response = await fetch(`/api/games/${gameId}/launch/${queryParam}`)

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const data = await response.json()

    if (data.Code) {
      handleErrorCode(data.Code)
    } else {
      console.log('Game Data:', data.LaunchUrl)
      window.location.assign(data.LaunchUrl)
    }
  } catch (error) {
    console.error('Failed to fetch game details:', error)
  } finally {
    setLoading(false)
  }
}

export const handleErrorCode = (code, showErrorMessage, openRegistrationForm) => {
  let message

  switch (code) {
    case -1:
      message = {
        en: 'Failed to find the player in the system.',
        ru: 'Системаная ошибка (Не удалось найти игрока в системе).',
      }
      break
    case -2:
    case -3:
      openRegistrationForm()
      // message = {
      //   en: 'The game is temporarily unavailable; please try again later.',
      //   ru: 'Игра временно недоступна, повторите попытку позже.',
      // }
      break
    case -4:
      openRegistrationForm()
      break
    case -5:
      message = {
        en: 'Platform not supported.',
        ru: 'Платформа не поддерживается.',
      }
      break
    default:
      message = {
        en: 'An unknown error occurred.',
        ru: 'Произошла неизвестная ошибка.',
      }
  }

  showErrorMessage(message)
}

export const showErrorMessage = message => {
  alert(message.ru)
}

export const openRegistrationForm = setShowSignIn => {
  setShowSignIn(true)
}

// gameUtils.js

export const renderGame = (game, handleGameClickWrapper, favoriteGames, pinGame, unpinGame) => {
  const isFavorite = favoriteGames.some(g => g.Id === game.Id)
  const handleFavoriteClick = e => {
    e.stopPropagation()
    if (isFavorite) {
      unpinGame(game.Id) // Call unpinGame if already a favorite
    } else {
      pinGame(game.Id) // Call pinGame if not a favorite
    }
  }
  return (
    <div key={game.Id} className="game-card" onClick={() => handleGameClickWrapper(game.Id)}>
      <div className="game-thumbnail">
        { (game.ThumbnailUrl || '').endsWith(".mp4")
        ? (<video poster={game.ThumbnailUrl} autoPlay muted loop controls={false} className="game-image">
            <source src={game.ThumbnailUrl} type="video/mp4" />
          </video>)
        : (<img src={game.ThumbnailUrl} alt={`Game ${game.Name}`} className="game-image" />)
        }
          
          
        <h3 className="game-title">{game.Name}</h3>

        <button
          className={`favorite-button ${isFavorite ? 'favorite' : ''}`}
          onClick={handleFavoriteClick}
        >
          {isFavorite ? '★' : '☆'}
        </button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/GamesPageNewLayout/gameUtils.jsx